import React, { useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";
import { useHistory, useLocation } from "react-router-dom";
import {
  routeList,
  ROUTE_LOGIN,
  ROUTE_ADMINS_MENU,
  ROUTE_PANEL,
} from "../routes/routesConstants";
import alphabet from "../../images/alphabet_logo.svg";
import pauta from "../../images/pautaLogo.png";
import bosch from "../../images/bosch-logo-navbar.svg";
import ClientLogo from "../../images/logo_GAC.webp";

import { Button, IconButton } from "@material-ui/core";
import { useState } from "react";
import { RentalMenu } from "./RentalMenu";
import { FactoryStatusAlert } from "../common/FactoryStatusAlert";
import { AdminMenu } from "./AdminMenu";
import { isUserInRoles } from "../../commonFunctions/commonFunctions";
import { ADMIN, MANAGER } from "../../Constantes/userRoles";
import { useSelector } from "react-redux";
import {
  selectUser,
  selectUserRoles,
  selectUserSuperAdmin,
} from "../../redux/authentication/selectors";
import { NavbarButton } from "./NavbarButton";
import adminIcon from "../../images/user-tie.svg";
import externalLinksIcon from "../../images/ui-ic-externallink.svg";
import arrowRight from "../../images/arrow-right.svg";
import arrowDown from "../../images/arrow-down.svg";
import { AccountCircle } from "@material-ui/icons";
import { ProfileMenu } from "./ProfileMenu";
import ProfileDialog from "./ProfileDialog";
import { useTranslation } from "react-i18next";

const useStyles = makeStyles((theme) => ({
  root: {
    maxWidth: "100vw",
    display: "grid",
    gridTemplateRows: "min-content 1fr",
  },
  buttonLink: {
    color: "#397CB7",
    textTransform: "none",
    fontSize: "0.9125rem",
  },
  button: {
    backgroundColor: "#EF7D00",
    boxShadow: "none",
    borderRadius: "1.5625rem",
    textTransform: "none",
    color: "white",
    "&:hover": {
      backgroundColor: "#FBBA00",
      boxShadow: "none",
    },
    marginRight: "1.5625rem",
    marginLeft: "1.5625rem",
    fontWeight: theme.typography.fontWeightMedium,
    fontSize: "0.9125rem",
  },
}));

export default function CenteredTabs() {
  const { t } = useTranslation();
  const history = useHistory();
  const location = useLocation();
  const [openProfileMenu, setOpenProfileMenu] = useState(false);
  const [openRentalMenu, setOpenRentalMenu] = useState(false);
  const [openAdminMenu, setOpenAdminMenu] = useState(false);
  const [showBar, setShowbar] = useState(true);
  const classes = useStyles();
  const [showProfileDialog, setShowProfileDialog] = useState(false);
  const profileAnchorRef = React.useRef(null);
  const rentalAnchorRef = React.useRef(null);
  const adminAnchorRef = React.useRef(null);
  const userRoles = useSelector(selectUserRoles);
  const userSuperAdmin = useSelector(selectUserSuperAdmin);
  const user = useSelector(selectUser);

  const adminButtonSelected = location.pathname.includes(ROUTE_ADMINS_MENU);

  function handleMenuClick(url) {
    history.push(url);
  }

  useEffect(() => {
    if (location.pathname === ROUTE_LOGIN) {
      setShowbar(false);
    } else {
      setShowbar(true);
    }
  }, [location]);

  return (
    <div className={classes.root}>
      <div className="navbar-header"></div>
      {showBar ? (
        <nav className="main-navbar">

          {/* <div style={{ margin: 5 }}>
          <img src={alphabet} style={{width: "11.5625rem"}} alt="" />
        </div>
        <div style={{ margin: 5, flexGrow: 1 }}>
          <img src={pauta} style={{height: "1.5rem"}} alt="" />
        </div> */}

          <div style={{ marginLeft: "1rem", flexGrow: 1, display: "flex", alignItems: "center", gap: ".4rem", cursor: "pointer" }} onClick={(e) => history.push(ROUTE_PANEL)}>
            <img src={bosch} style={{ width: "8rem" }} alt="" />
            <div>
              <span style={{fontSize: "2rem", fontWeight: 100, color: "#828385"}}>|</span>
            </div>
            <img src={ClientLogo} style={{height: "1.6rem"}}></img>
          </div>


          {/* <div style={{margin: 5}}>
          <FactoryStatusAlert/>
        </div> */}

          {isUserInRoles([ADMIN, MANAGER], userRoles, userSuperAdmin) && (
            <Button
              startIcon={
                <img
                  className={
                    adminButtonSelected ? "navbar-icon-selected" : "navbar-icon"
                  }
                  src={adminIcon}
                />
              }
              endIcon={
                openAdminMenu ? (
                  <img
                    style={{ width: "0.625rem", height: "0.625rem" }}
                    className={
                      adminButtonSelected
                        ? "navbar-icon-selected"
                        : "navbar-icon"
                    }
                    src={arrowDown}
                  />
                ) : (
                  <img
                    style={{ width: "0.625rem", height: "0.625rem" }}
                    className={
                      adminButtonSelected
                        ? "navbar-icon-selected"
                        : "navbar-icon"
                    }
                    src={arrowRight}
                  />
                )
              }
              ref={adminAnchorRef}
              onClick={() => setOpenAdminMenu(!openAdminMenu)}
              aria-controls={openAdminMenu ? "menu-list-grow" : undefined}
              aria-haspopup="true"
              variant="text"
              disableRipple
              style={{ marginRight: "1rem" }}
              color={adminButtonSelected ? "primary" : "secondary"}
            >
              {t("Header.Menu.Admin")}
            </Button>
          )}
          <AdminMenu
            open={openAdminMenu}
            handleClose={setOpenAdminMenu}
            anchor={adminAnchorRef}
            handleMenuClick={handleMenuClick}
          />
          <div
            style={{
              display: "flex",
              columnGap: "1rem",
              alignItems: "center",
              marginRight: "1rem",
            }}
          >
            {routeList
              .filter((route) =>
                isUserInRoles(route.allowedRoles, userRoles, userSuperAdmin)
              )
              .map((route) => (
                <NavbarButton
                  key={route.path}
                  path={route.path}
                  icon={route.icon}
                  label={t(route.translationMap)}
                  onClickfn={handleMenuClick}
                />
              ))}
          </div>
          {/* <div>
            <Button
              startIcon={
                <img
                  className={
                    openRentalMenu ? "navbar-icon-selected" : "navbar-icon"
                  }
                  src={externalLinksIcon}
                />
              }
              color={openRentalMenu ? "primary" : "secondary"}
              endIcon={
                openRentalMenu ? (
                  <img
                    style={{ width: "0.625rem", height: "0.625rem" }}
                    className={"navbar-icon-selected"}
                    src={arrowDown}
                  />
                ) : (
                  <img
                    style={{ width: "0.625rem", height: "0.625rem" }}
                    className={"navbar-icon"}
                    src={arrowRight}
                  />
                )
              }
              ref={rentalAnchorRef}
              onClick={() => setOpenRentalMenu(!openRentalMenu)}
              disableRipple
              aria-controls={openRentalMenu ? "menu-list-grow" : undefined}
              aria-haspopup="true"
            >
              {" "}
              {t("Header.ExternalLinks.Name")}
            </Button>
            <RentalMenu
              open={openRentalMenu}
              handleClose={setOpenRentalMenu}
              anchor={rentalAnchorRef}
            />
          </div> */}
          <div style={{ marginRight: 15 }}>
            <IconButton
              ref={profileAnchorRef}
              edge="end"
              aria-label="account of current user"
              aria-controls="primary-search-account-menu"
              aria-haspopup="true"
              //onClick={handleProfileMenuOpen}
              onClick={() => setOpenProfileMenu(!openProfileMenu)}
              color="inherit"
            >
              <AccountCircle />
            </IconButton>
            <ProfileMenu
              open={openProfileMenu}
              handleClose={setOpenProfileMenu}
              anchor={profileAnchorRef}
              setShowProfileDialog={setShowProfileDialog}
            />
          </div>
          <ProfileDialog
            title={t("UserProfile")}
            dialogSize={{ height: "100%" }}
            open={showProfileDialog}
            onClose={() => setShowProfileDialog(false)}
          ></ProfileDialog>
        </nav>
      ) : null}
    </div>
  );
}
